import { getEnding } from "../game/endingResolver";
import type { GameState, PlayerProfile } from "../types";
import { formatDuration } from "../utils";

interface EndingScreenProps {
  run: GameState;
  profile: PlayerProfile;
  onReplay: () => void;
  onTitle: () => void;
}

export function EndingScreen({ run, profile, onReplay, onTitle }: EndingScreenProps) {
  const ending = getEnding(run.endingId);
  const elapsed = Math.max(0, Math.floor((new Date(run.lastUpdatedAt).getTime() - new Date(run.startedAt).getTime()) / 1000));
  return (
    <main className="ending-screen">
      <section className="ending-report">
        <div className="ending-code">SHIFT RECORD / {run.runId.slice(0, 8).toUpperCase()}</div>
        <h1>{ending?.title ?? "勤務記録終了"}</h1>
        <p className="ending-description">{ending?.description}</p>
        <div className="ending-stats">
          <div><span>正解数</span><strong>{run.correctCount}</strong></div>
          <div><span>誤判定</span><strong>{run.mistakeCount}</strong></div>
          <div><span>巻き戻り</span><strong>{run.loopCount}</strong></div>
          <div><span>発見異変</span><strong>{run.discoveredAnomalyIds.length}</strong></div>
          <div><span>勤務時間</span><strong>{formatDuration(elapsed)}</strong></div>
          <div><span>確認済み結末</span><strong>{profile.endings.length}</strong></div>
        </div>
        <div className="ending-actions"><button type="button" className="primary-button" onClick={onReplay}>もう一度勤務する</button><button type="button" onClick={onTitle}>タイトルへ戻る</button></div>
      </section>
    </main>
  );
}
